export const textStyles = {
  h1: `text-2xl text-blog-purply-pink-300 font-bold`,
  h2: `text-xl text-blog-purply-pink-300 font-bold`,
  h3: `text-lg text-blog-purply-pink-300 font-bold pt-4`,
  a: 'text-blog-link-blue underline hover:text-blog-link-blue-hover focus:text-blog-link-blue-hover',
  a_no_underline:
    'text-blog-link-blue hover:text-blog-link-blue-hover hover:underline focus:text-blog-link-blue-hover focus:underline',
  figcaption: `text-[14px] text-blog-dusty-black-300 italic mt-1`,
}
